// RequestsContext — the cross-cutting request list + its loaders/counts.
//
// Phase 3 of the portal.jsx architecture refactor (docs/portal-architecture-refactor-plan.md
// §2.5). Same CONSERVATIVE shape as SessionContext: App still OWNS the state (the `requests`
// useState + the usePortalData loaders + the task counts stay in portal.jsx); this context
// only EXPOSES that already-built value so the list screens stop receiving `requests`,
// `loadRequests` and the counts as props.
//
// Usage:
//   <RequestsProvider value={{ requests, loadRequests, unactionedTaskCount, pickerTaskCount }}>
//   const { requests } = useRequests();

import { createContext, useContext } from "react";

const RequestsContext = createContext(null);

export function RequestsProvider({ value, children }) {
  return <RequestsContext.Provider value={value}>{children}</RequestsContext.Provider>;
}

export function useRequests() {
  const ctx = useContext(RequestsContext);
  if (ctx === null) {
    throw new Error("useRequests must be used within a RequestsProvider");
  }
  return ctx;
}
